package com.patronat.top.client.domain.venues

import com.patronat.top.client.data.venues.ClientVenuesRepository
import com.patronat.top.core.dispatchers.DispatcherProvider
import com.patronat.top.core.domain.models.DomainResult
import com.patronat.top.domain.usecase.BaseUseCase
import com.patronat.top.dto.VenueFilterRequest
import com.patronat.top.dto.VenueListResponse

class GetClientVenuesUseCase(
    private val repository: ClientVenuesRepository,
    dispatcherProvider: DispatcherProvider
) : BaseUseCase<VenueFilterRequest, DomainResult<VenueListResponse>>(
    dispatcher = dispatcherProvider.io
) {
    override suspend fun doWork(command: VenueFilterRequest): DomainResult<VenueListResponse> {
        return repository.getVenues(command)
    }
}
